import React from 'react'
import gql from 'graphql-tag'
import {Link} from 'react-router-dom'
import {List, Button} from 'antd'
import {
  UserOutlined,
  PhoneOutlined,
  CameraOutlined,
  CalendarOutlined,
  EnvironmentOutlined
} from '@ant-design/icons'
import t from 'lib/translations'
import Query from 'shared/components/Query'
import Layout from 'components/PrivateRoutes/Layout'

import './index.css'

export const ProfileQuery = gql`
  query ProfileQuery {
    serviceProvider {
      id
      name
      capability
      coveragePoints {
        id
        name
      }
    }
  }
`

const Profile = (props) => {
  return (
    <Layout {...props} title="Profil">
      <div className="profile">
        <Query
          query={ProfileQuery}
          inlineLoading
          inlineError
        >
          {({getData}) =>
            <div className="section user-info">
              <List>
                <List.Item>
                  <UserOutlined />
                  <span>
                    {getData('serviceProvider.name')}
                  </span>
                </List.Item>

                <List.Item>
                  <CameraOutlined />
                  {getData('serviceProvider.capability').map(name =>
                    <span key={name}>
                      {t(`capability.${name}`) + ','}
                    </span>
                  )}
                </List.Item>

                <List.Item>
                  <EnvironmentOutlined />
                  {getData('serviceProvider.coveragePoints').map(({id, name}) =>
                    <span key={id}>
                      {name + ','}
                    </span>
                  )}
                </List.Item>
              </List>
            </div>
          }
        </Query>

        <div className="section actions">
          <Link to="/availability">
            <Button
              block
              size="large"
              icon={<CalendarOutlined />}
            >
              Tilgjengelighet
            </Button>
          </Link>

          <Button
            block
            size="large"
            href="tel:21080500"
          >
            <PhoneOutlined className="contact-icon" />
            Kontakt kundeservice
          </Button>
        </div>
      </div>
    </Layout>
  )
}

export default Profile
